import { ReactNode } from "react";
import { IconLeftArrowVersion2 } from "../../../../icons";

interface IHeader {
  handleClickExit?: () => void;
  total?: string;
  exit?: boolean;
  title?: string | ReactNode;
  hoursAndMinutes?: boolean;
}

export default function Header({ handleClickExit, exit = false, total, title, hoursAndMinutes = true }: IHeader) {
  return (
    <>
      <div className="header-hours-management flex font-roboto bold between center">
        <div className="sub-header-hours-management box-title color-text-contrast">
          <div className={`flex row ${exit && "gap"}`}>
            {exit && (
              <span onClick={handleClickExit} className="pointer">
                {IconLeftArrowVersion2}
              </span>
            )}
            {title ? (
              <h1 className="title-subHeader-hours-management">{title}</h1>
            ) : (
              <span className="bankHours-subHeader-hours-management">Banco de Horas</span>
            )}
          </div>
        </div>
        <div className="total-hours">
          {total}
          {hoursAndMinutes && (
            <div className="hours-minutes row box-row">
              <span>horas</span> <span>minutos</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
